import React from 'react';
import { LessonType, LiveState } from '../../redux/types/live.type';
import moment from 'moment';

export interface PlaybackConfig {
  canPlayback: boolean;
  effectiveDays: number;
  effectiveTime: number;
  enable: boolean;
}

interface LiveStateTxtProps {
  liveState: LiveState;
  lessonType: LessonType;
  startTime: number;
  playbackConfig: PlaybackConfig;
  live: {
    hasPlayback: boolean; // 是否有回放
  };
}

// 必须要在结束状态下才使用
export const LiveFinishTxt = (playbackConfig: PlaybackConfig, live: { hasPlayback: boolean }) => {
  if ((playbackConfig as PlaybackConfig)?.canPlayback) {
    // 已经生成回放
    if (live?.hasPlayback) {
      return playbackConfig.effectiveTime
        ? moment(playbackConfig.effectiveTime).format('YYYY/MM/DD HH:mm:ss 前可回放')
        : '已结束';
    } else {
      return '回放最晚将于次日0点生成，请耐心等待';
    }
  } else {
    return '已结束';
  }
};

export const LiveGenerateTxt = (props: LiveStateTxtProps) => {
  const { liveState, startTime, playbackConfig, live } = props;
  if (liveState === LiveState.WaitLive) {
    return `${moment(startTime).format('YYYY/MM/DD HH:mm:ss')} 开始直播`;
  }

  if (liveState === LiveState.OnLive) {
    return '直播中，结束后可查看回放';
  }

  if (liveState === LiveState.FinishLive) {
    return LiveFinishTxt(playbackConfig, live);
  }

  return '';
};

export const LiveStateTxt = (props: LiveStateTxtProps) => {
  const { lessonType } = props;

  if (lessonType !== LessonType.Live) return null;

  const liveTxt = LiveGenerateTxt(props);

  return (
    <span className="liveStatus">
      {liveTxt !== '已结束' ? <span>{liveTxt}</span> : <span className="liveEnd">{liveTxt}</span>}
    </span>
  );
};
